<template>
    <v-dialog v-model="handleDialog" width="1000" class="common-dialog">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <validation-observer ref="observer" v-slot="{ invalid }" >
            <form @submit.prevent="pushOk">
                <v-card color="#F4FEFB">
                    <v-card-title class="justify-center text-h5">
                        <p v-if="currentIndex !== null">共有先編集</p><p v-else>共有先追加</p>
                    </v-card-title>
                    <v-card-text class="common-dialog-message">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="3">
                                    <badge-component tile content="必　須">
                                        <label-component>氏名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="required|max:100" name="share_destination_name" v-slot="{ errors }">
                                        <v-text-field outlined clearable v-disabled-icon-focus v-model="share_destination_name" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="3">
                                    <badge-component tile content="必　須">
                                        <label-component>メールアドレス</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider rules="required|email|max:255" name="share_destination_email_address" v-slot="{ errors }">
                                        <v-text-field required outlined clearable v-disabled-icon-focus v-model="share_destination_email_address" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" xl="3">
                                    <badge-component tile content="任　意">
                                        <label-component>会社名</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="7">
                                    <validation-provider v-slot="{ errors }" name="destination_company_name" rules="max:50" >
                                        <v-text-field outlined clearable v-disabled-icon-focus v-model="destination_company_name" :error-messages="errors" background-color="white"></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="justify-center grey lighten-4 pb-6">
                        <v-btn min-width="150px" class="white--text" color="red" large :disabled="invalid" @click="pushOk">
                            <slot name="ok-btn"></slot>
                        </v-btn>
                        <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false;">
                            <slot name="cancel-btn"></slot>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </validation-observer>
    </v-dialog>
</template>

<script>
  import { required, email, max } from 'vee-validate/dist/rules';
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';

  extend('required', {
    ...required,
    message: '入力必須項目です',
  });

  extend('email', {
    ...email,
    message: '正しいメールアドレスをご入力ください',
  });

  extend('max', {
    ...max,
    message: '{length} 文字以内でご入力ください',
  });

export default {
    components: {
          ValidationProvider,
          ValidationObserver,
    },
    data() {
        return {
            item: null,
            message: {
                success: false,
                text: '',
            },
        };
    },
    props: {
        currentSharingList: Array,
        currentIndex: Number,
        currentItem: Object,
        // ダイアログの開閉
        sharingDialog: Boolean,
    },
    // 初期表示のデータ
    created : function() {
        this.item = this.currentItem;
    },
    computed: {
        id: {
            get() {
                return this.currentItem.id;
            },
        },
        share_destination_name: {
            get() {
                return this.currentItem.share_destination_name;
            },
            set(value) {
                this.item.share_destination_name = value;
            }
        },
        share_destination_email_address: {
            get() {
                return this.currentItem.share_destination_email_address;
            },
            set(value) {
                this.item.share_destination_email_address = value;
            }
        },
        destination_company_name: {
            get() {
                return this.currentItem.destination_company_name;
            },
            set(value) {
                this.item.destination_company_name = value;
            }
        },
        handleDialog: {
            get() {
                return this.sharingDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:sharingDialog', value);
            }
        },
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    methods: {
        // 更新
        pushOk: function() {
            let self = this;
            this.$refs.observer.validate().then((result) => {
                if(result) {
                    let find = self.currentSharingList.find(item => item.share_destination_email_address == self.currentItem.share_destination_email_address);
                    if (find != null && self.currentSharingList.indexOf(find) != self.currentIndex) {
                        self.message.text = "すでに宛先に設定されているメールアドレスです";
                        self.message.success = false;
                        return false;
                    }
                    // 親コンポーネントへの通知
                    this.$emit("clickOk", this.item);
                    this.handleDialog = false;
                }
            });
        }
    },
};
</script>

<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>
